import type { ReactNode } from "react";
import { ArrowLeft } from "lucide-react";

/**
 * The top of every page: an optional back link, a small eyebrow (the menu
 * group), the page title (the only h1), one plain sentence saying what the
 * page is for, a row of status badges, and the page's main actions on the
 * right (they wrap under the title on phones).
 */
export function PageHeader({
  eyebrow,
  title,
  description,
  actions,
  meta,
  back,
}: {
  eyebrow?: string;
  title: string;
  description?: ReactNode;
  actions?: ReactNode;
  /** Badges or a freshness line under the description. */
  meta?: ReactNode;
  back?: { label: string; onClick: () => void };
}) {
  return (
    <div className="page-head">
      <div className="page-head-text">
        {back && (
          <button type="button" className="text-button page-back" onClick={back.onClick}>
            <ArrowLeft size={14} /> {back.label}
          </button>
        )}
        {eyebrow && <div className="eyebrow">{eyebrow}</div>}
        <h1>{title}</h1>
        {description && <p>{description}</p>}
        {meta && <div className="page-head-meta">{meta}</div>}
      </div>
      {actions ? <div className="head-actions">{actions}</div> : <div className="head-actions" />}
    </div>
  );
}
